import { memoize } from '@sail/utils';
import urlToFullLocation from '../internal/urlToFullLocation';
export default memoize(function urlToLocation(url) {
    const location = urlToFullLocation(url);
    const search = Object.fromEntries(Object.entries(location.search).filter(([key])=>!key.startsWith('_')));
    return Object.assign({}, location, {
        search
    });
});

//# sourceMappingURL=urlToLocation.js.map